import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ContractStatementViewPDF extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    fetchResult(req) {
        return this.repo.viewContractPDF(req);
    }
}
export default ContractStatementViewPDF;
